"use client";
import { Button } from "@softmax/design-system";
import { useEffect, useRef, useState } from "react";

export function CopyReplayText({
  text,
  label,
}: {
  text: string;
  label: string;
}) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;

      if (timer.current !== null) clearTimeout(timer.current);
    };
  }, []);

  const copy = async () => {
    await navigator.clipboard.writeText(text);

    if (!mounted.current) return;

    if (timer.current !== null) clearTimeout(timer.current);

    setCopied(true);
    timer.current = setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button size="sm" variant="quiet" onClick={copy}>
      {copied ? "Copied!" : label}
    </Button>
  );
}
